// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InputDate_input__date__FmJXQ {
	position: relative;
	width: 15rem;
	height: 3.125rem;

	border-radius: 0.4375rem;
	border: 1px solid var(--accent-color, #956446);
	background: white;

	box-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;

	padding: 0.31rem 1.25rem;
}

.InputDate_form__sjF4x {
	position: relative;
}

.InputDate_input__text_side__UesH8 {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 0.2rem;
	align-items: flex-start;
}

.InputDate_input__title__fqHsN {
	color: var(--pink-color, #d7bbbb);
	text-align: center;

	/* text super small */
	font-family: 'Noto Sans';
	font-size: 0.75rem;
	font-style: normal;
	font-weight: 500;
	line-height: 100%; /* 1.2rem */
}

.InputDate_input__text__BvAmv {
	color: var(--accent-color, #956446);
	text-align: center;

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 100%;
}

.InputDate_date__picker__WBt\\+N {
	position: absolute;
	top: -21rem;
	left: -2.5rem;
}

@media (max-width: 460px) {
	.InputDate_form__sjF4x {
		width: 100%;
	}
	.InputDate_input__date__FmJXQ {
		width: 100%;
	}
	.InputDate_date__picker__WBt\\+N {
		position: absolute;
		top: -20rem;
		left: 0;
		width: 100%;
	}
	.InputDate_input__text__BvAmv {
		font-size: 0.9375rem;
	}
}

@media (max-width: 400px) {
	.InputDate_date__picker__WBt\\+N {
		position: absolute;
		top: -20rem;
	}
}

@media (max-width: 360px) {
	.InputDate_date__picker__WBt\\+N {
		position: absolute;
		top: -19rem;
	}
}

@media (max-width: 320px) {
	.InputDate_date__picker__WBt\\+N {
		position: absolute;
		top: -19rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/DateFrame/InputDate/InputDate.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;;CAEhB,wBAAwB;CACxB,8CAA8C;CAC9C,iBAAiB;;CAEjB,qDAAqD;CACrD,eAAe;CACf,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;;CAEnB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,iCAAiC;CACjC,kBAAkB;;CAElB,qBAAqB;CACrB,wBAAwB;CACxB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,mCAAmC;CACnC,kBAAkB;;CAElB,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;AACd;;AAEA;CACC;EACC,WAAW;CACZ;CACA;EACC,WAAW;CACZ;CACA;EACC,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;CACZ;CACA;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,WAAW;CACZ;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,WAAW;CACZ;AACD;;AAEA;CACC;EACC,kBAAkB;EAClB,WAAW;CACZ;AACD","sourcesContent":[".input__date {\n\tposition: relative;\n\twidth: 15rem;\n\theight: 3.125rem;\n\n\tborder-radius: 0.4375rem;\n\tborder: 1px solid var(--accent-color, #956446);\n\tbackground: white;\n\n\tbox-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);\n\tcursor: pointer;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\n\tpadding: 0.31rem 1.25rem;\n}\n\n.form {\n\tposition: relative;\n}\n\n.input__text_side {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\tgap: 0.2rem;\n\talign-items: flex-start;\n}\n\n.input__title {\n\tcolor: var(--pink-color, #d7bbbb);\n\ttext-align: center;\n\n\t/* text super small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 0.75rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 100%; /* 1.2rem */\n}\n\n.input__text {\n\tcolor: var(--accent-color, #956446);\n\ttext-align: center;\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 100%;\n}\n\n.date__picker {\n\tposition: absolute;\n\ttop: -21rem;\n\tleft: -2.5rem;\n}\n\n@media (max-width: 460px) {\n\t.form {\n\t\twidth: 100%;\n\t}\n\t.input__date {\n\t\twidth: 100%;\n\t}\n\t.date__picker {\n\t\tposition: absolute;\n\t\ttop: -20rem;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t}\n\t.input__text {\n\t\tfont-size: 0.9375rem;\n\t}\n}\n\n@media (max-width: 400px) {\n\t.date__picker {\n\t\tposition: absolute;\n\t\ttop: -20rem;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.date__picker {\n\t\tposition: absolute;\n\t\ttop: -19rem;\n\t}\n}\n\n@media (max-width: 320px) {\n\t.date__picker {\n\t\tposition: absolute;\n\t\ttop: -19rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input__date": `InputDate_input__date__FmJXQ`,
	"form": `InputDate_form__sjF4x`,
	"input__text_side": `InputDate_input__text_side__UesH8`,
	"input__title": `InputDate_input__title__fqHsN`,
	"input__text": `InputDate_input__text__BvAmv`,
	"date__picker": `InputDate_date__picker__WBt+N`
};
export default ___CSS_LOADER_EXPORT___;
